import type { LucideIcon } from "lucide-react"

type ServiceSectionProps = {
  index: string
  eyebrow: string
  title: string
  description: string
  detail: string
  icon: LucideIcon
  side?: "left" | "right"
}

export function ServiceSection({ index, eyebrow, title, description, detail, icon: Icon, side = "left" }: ServiceSectionProps) {
  return (
    <section className={`service-panel service-panel--${side}`}>
      <div className="service-panel__sticky">
        <div className="service-copy">
          <div className="service-meta"><span>{index}</span><span>{eyebrow}</span></div>
          <div className="service-icon"><Icon size={22} strokeWidth={1.5} aria-hidden="true" /></div>
          <h2 className="service-title" aria-label={title}>
            {title.split(" ").map((word, wordIndex) => (
              <span className="word-mask" key={`${word}-${wordIndex}`} aria-hidden="true">
                <span>{word}&nbsp;</span>
              </span>
            ))}
          </h2>
          <p>{description}</p>
          <div className="service-detail">{detail}</div>
        </div>
      </div>
    </section>
  )
}
